import BaseComponent from '@utils/base.js';
import tag from '@utils/utilTags.js';

import * as styles from './change.module.scss';

import config from '@app/config.js';

const categories = {
  easy: config.NONOGRAMS.filter((item) => item.difficulty === 'easy'),
  medium: config.NONOGRAMS.filter((item) => item.difficulty === 'medium'),
  hard: config.NONOGRAMS.filter((item) => item.difficulty === 'hard'),
};

/** @extends {BaseComponent<HTMLDivElement>} */
export default class Change extends BaseComponent {
  /** @param {Props<HTMLDivElement> & {closeModal: () => void}} props */
  constructor(props) {
    super({ elementTag: 'div', classes: [styles.change] });

    Object.entries(categories).forEach(([difficulty, nonograms]) => {
      const list = tag.ul({ classes: [styles.list] });
      const details = tag.details(
        { classes: [styles.difficulty] },
        tag.summary({ text: difficulty, classes: [styles.summary] }),
        list
      );
      details.getElement().setAttribute('name', 'difficulty');

      nonograms.forEach((nonogram) => {
        const btn = tag.button({
          classes: [styles.btn],
          text: nonogram.name,
        });

        btn.addListener('click', () => {
          window.dispatchEvent(
            new CustomEvent('custom:changeNonogram', {
              detail: { id: nonogram.id },
            })
          );
          props.closeModal();
        });

        list.appendSingle(btn);
      });

      this.appendSingle(details);
    });
  }
}
